import React, { ReactNode } from 'react';
import { Action } from 'redux';
import { makeStyles } from '@material-ui/core/styles';

import {
  Dialog,
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  Grid,
} from '@material-ui/core';

import {
  Close as CloseIcon,
} from '@material-ui/icons';

import styles from './PopupDialog.styles';

type Props = {
  children?: React.ReactNode | React.ReactNode[];
  open?: boolean;
  title?: ReactNode | string;
  closeAction?: () => Action;
  renderCommandActions?: () => React.ReactNode | React.ReactNode[];
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  classes?: Partial<Record<'root' | 'content' | 'footer' | 'backdrop', string>>;
};

const useStyles = makeStyles(styles);
const PopupDialog: React.FC<Props> = ({
  children,
  open,
  title,
  closeAction,
  renderCommandActions,
  maxWidth,
  classes,
}: Props) => {
  const innerClasses = {
    ...useStyles(),
    ...classes,
  } as Record<string, string>;

  return (
    <Dialog
      classes={{ root: innerClasses.root }}
      open={open || false}
      maxWidth={maxWidth}
      BackdropProps={{
        classes: {
          root: innerClasses.backdrop,
        },
      }}
    >
      {title && (
        <DialogTitle
          className={innerClasses.title}
          disableTypography
          color="primary"
        >
          <Grid container>
            <Grid item container xs={10} alignItems="center">
              {typeof title === 'string' ? (
                <Typography variant="h6" color="inherit">{title}</Typography>
              ) : (
                title
              )}
            </Grid>
            <Grid item container xs={2} justifyContent="flex-end">
              {closeAction && (
                <IconButton
                  aria-label="Close"
                  className={innerClasses.closeButton}
                  onClick={() => closeAction()}
                  color="inherit"
                >
                  <CloseIcon color="inherit" />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </DialogTitle>
      )}
      <DialogContent classes={{ root: innerClasses.content }} dividers>
        {children}
      </DialogContent>
      {renderCommandActions && (
        <DialogActions classes={{ root: classes?.footer || innerClasses.footer }}>
          <Grid container justifyContent="flex-end">
            {renderCommandActions()}
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default PopupDialog;
